export const AttendeeAvatarList = () => {
  return (
    <div className="attendees-list">
      <img className="attendee-image" src={`/images/user-avatars/user-avatar-1.jpg`} />
      <img className="attendee-image" src={`/images/user-avatars/user-avatar-2.jpg`} />
      <img className="attendee-image" src={`/images/user-avatars/user-avatar-3.jpg`} />
      <div className="attendee-image attendee-image--additional">
        <span>+3</span>
      </div>
    </div>
  )
}
